import { Outlet } from "react-router-dom"
import BreadCrumbs from "../../components/main/Breadcrumbs"


export default function MainPageAgency() {

    return(
        <div className="flex flex-col gap-y-4 pt-2">
            <BreadCrumbs />
            <Outlet />
        </div>
    )
}